import React from "react";
import "./../assets/scss/Header.scss";

function Header() {
  return (
    <div className="header">
      <h1 data-shadow="Methods Matter">Methods Matter</h1>
    </div>
  );
}

export default Header;
